import React from "react";
import { useEffect, useState } from "react";
import { Heading } from "@chakra-ui/react";
import { CardBody } from "@paljs/ui/Card";
import { useQuery } from "graphql-hooks";

import { GenericErrorAlert } from "../../../components/alerts";
import Loading from "../../../components/loading";
import { Card } from "../../../components/paljs";
import { GetConsentsQuery } from "../../../types";

import Agreements from "./agreementsLogic";
import { GET_CONSENTS } from "./data";
import { requiredConsents } from "./fixtures";

function CheckoutAgreementsLogic() {
  const [hasRequiredConsents, setHasRequiredConsents] = useState(false);

  const [consents, setTempConsents] = useState<Record<string, boolean>>({});
  const { loading, data, error } = useQuery<GetConsentsQuery>(GET_CONSENTS);

  useEffect(() => {
    if (data?.me?.consents) {
      const { __typename, ...serverConsents } = data.me.consents;
      setTempConsents(serverConsents);
    }
  }, [loading, data]);

  const onSetConsent = (consents: GetConsentsQuery["me"]["consents"]) => {
    const { __typename, ...newConsents } = consents; // typy z dupy

    // mutacja z consentem tu
    console.log("mutacja z consentem dla uzytkownika", newConsents);

    setTempConsents(newConsents);
  };

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <GenericErrorAlert />;
  }
  console.log(consents);
  return (
    <Agreements
      requiredConsents={requiredConsents}
      setHasRequiredConsents={setHasRequiredConsents}
      setConsents={onSetConsent}
      consents={consents}
    />
  );
}

const CheckoutAgreementsLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Card>
    <CardBody>
      <>
        <Heading fontSize="lg" padding={0} color={"gray.700"} mb={3}>
          Zgody i regulaminy
        </Heading>
        {children}
      </>
    </CardBody>
  </Card>
);

export default function CheckoutAgreements() {
  return (
    <CheckoutAgreementsLayout>
      <CheckoutAgreementsLogic />
    </CheckoutAgreementsLayout>
  );
}
